const JobCard = ({ job }) => {
  return (
    <div
      onClick={() => window.open(job.url, "_blank")}
      className="bg-white border border-gray-200 rounded-2xl p-6 hover:shadow-xl transition cursor-pointer relative"
    >
      {/* Badge */}
      <span className="absolute top-4 right-4 text-xs px-3 py-1 rounded-full bg-green-100 text-green-700">
        {job.employment_type || "FULL_TIME"}
      </span>

      {/* Title */}
      <h3 className="text-xl font-semibold text-gray-900">
        {job.title}
      </h3>

      {/* Company */}
      <p className="text-sm text-gray-500 mt-1">
        🏢 {job.company || "Confidential"}
      </p>

      {/* Meta */}
      <div className="flex flex-wrap gap-3 text-sm text-gray-600 mt-4">
        {job.location && <span>📍 {job.location}</span>}
        <span>🕒 Recently posted</span>
      </div>

      {/* CTA */}
      <button
        className="mt-6 w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-lg font-medium"
      >
        Apply Now →
      </button>
    </div>
  );
};

export default JobCard;
